/**
 * Times are shown in the viewer's own time zone with its abbreviation (D-047), for example
 * "2026-09-04 16:00 CDT". The API stores and sends UTC ISO strings; only the display converts.
 * `timeZone` exists for tests; the app never passes it.
 */
export function formatWhen(iso: string, timeZone?: string): string {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  const parts = new Intl.DateTimeFormat('en-US', {
    timeZone,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hourCycle: 'h23',
    timeZoneName: 'short',
  }).formatToParts(d);
  const p = (t: Intl.DateTimeFormatPartTypes) => parts.find((x) => x.type === t)?.value ?? '';
  return `${p('year')}-${p('month')}-${p('day')} ${p('hour')}:${p('minute')} ${p('timeZoneName')}`;
}
